<p-message
    severity="error"
    variant="text"
    class="text-center"
    styleClass="w-full text-center !rounded-none">
    <ng-template class="w-full mx-auto" #container>
        <div class="w-full mx-auto">
            Your account is suspended.

            <fa-icon
                [icon]="faInfoCircle"
                (click)="openSuspension.emit()"
                style="cursor: pointer"></fa-icon>
        </div>
    </ng-template>
</p-message>
